import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecOn = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM15.2891 7C13.6756 7.00011 12.4424 8.14899 12.4424 10.1426C12.4424 12.1362 13.6503 13.2851 15.2891 13.2852C16.8435 13.2852 17.79 12.2541 17.9336 11.1221L16.6494 11.1143C16.5227 11.7729 16.0075 12.161 15.3066 12.1611C14.3689 12.1611 13.7354 11.4604 13.7354 10.1426C13.7354 8.85859 14.36 8.12411 15.3145 8.12402C16.0239 8.12402 16.5479 8.53731 16.6494 9.21289H17.9336C17.7645 7.81081 16.6997 7 15.2891 7ZM2 7.08398V13.2002H3.26758V11.0283H4.23828L5.4043 13.2002H6.80664L5.50586 10.8174C6.20276 10.5217 6.58691 9.91346 6.58691 9.07715C6.58687 7.86924 5.79311 7.08407 4.39941 7.08398H2ZM7.46582 7.08398V13.2002H11.5801V12.1523H8.7334V10.665H11.3604V9.61816H8.7334V8.13086H11.5713V7.08398H7.46582ZM4.16309 8.12305C4.91459 8.12318 5.2773 8.46065 5.27734 9.07715C5.27734 9.68527 4.91463 9.99792 4.16309 9.99805H3.26758V8.12305H4.16309Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgRecOn);
export default ForwardRef;
